(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["og-editorial-hero"] && !Shopify.designMode) return;
  try {
    
function initOgunFilms() {
  document.querySelectorAll('.og-film').forEach(film => {
    if (film.dataset.ready) return;
    film.dataset.ready = 'true';
    const navigation = film.querySelector('.og-film__nav');
    const closeMenus = event => {
      navigation?.querySelectorAll('details[open]').forEach(menu => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    };
    const escapeMenus = event => {
      if (event.key !== 'Escape') return;
      const menu = navigation?.querySelector('details[open]');
      if (menu) {menu.open = false;menu.querySelector('summary')?.focus();}
    };
    document.addEventListener('click', closeMenus);
    document.addEventListener('keydown', escapeMenus);
    const video = film.querySelector('video');
    const button = film.querySelector('.og-film__motion');
    const header = document.querySelector('[data-theme-header]');
    const announcement = document.querySelector('[id$="__announcement"]');
    const measure = () => {
      film.style.setProperty('--og-header-height', (header?.getBoundingClientRect().height || 64) + 'px');
      film.style.setProperty('--og-announcement-height', (announcement?.getBoundingClientRect().height || 0) + 'px');
    };
    measure();
    const updateHeader = () => document.body.classList.toggle('og-film-past', film.getBoundingClientRect().bottom <= (header?.getBoundingClientRect().height || 64));
    window.addEventListener('scroll', updateHeader, {passive:true});
    window.addEventListener('resize', updateHeader);
    updateHeader();
    const observer = new ResizeObserver(measure);
    if (header) observer.observe(header);
    if (announcement) observer.observe(announcement);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(film)) {observer.disconnect();document.removeEventListener('click', closeMenus);document.removeEventListener('keydown', escapeMenus);window.removeEventListener('scroll', updateHeader);window.removeEventListener('resize', updateHeader);document.body.classList.remove('og-film-past');}
    }, {once:true});
    if (!video) return;
    button.hidden = false;
    const sync = () => {button.textContent = video.paused ? button.dataset.play : button.dataset.pause;};
    video.addEventListener('playing', () => {film.classList.add('og-film--playing');sync();});
    video.addEventListener('pause', sync);
    button.addEventListener('click', () => {if (video.paused) video.play().catch(sync); else video.pause();});
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(sync);
    sync();
  });
}
initOgunFilms();
document.addEventListener('shopify:section:load', initOgunFilms);

  } catch(e) { console.error(e); }
})();
})();
